// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-Attachments-Attachments-module__container--2dGEI","saveButton":"src-components-Attachments-Attachments-module__saveButton--3Szz2"};